<template>
    <div class="c-office-filter__sticky-wrapper">
        <div class="c-office-filter__show-filters-banner" v-if="!showFilters && !isDesktop">
            <div v-if="!isDesktop" id="mobilemap" class="googlemapoffice">
                <v-google-map v-if="!isDesktop" :selectedPlaces="selectedPlaces" :selectedTypesOfBuildings="selectedTypesOfBuildings"
                    :minSize="minSize" :maxSize="maxSize" :objects="this.objects" :apiKey="this.apiKey" />
            </div>
            <div class="filter-find-local">
                <button class="filter-local-button" @click="toggleFilterPanel">
                    <div class="container-filter-local">
                        <span aria-hidden="true" class="c-icon c-icon--xs slider-icon">
                            <svg>
                                <use xlink:href="#icon-sliders"></use>
                            </svg>
                        </span>
                        <span class="filter-local-text">{{this.translate.findpremise}}</span>
                    </div>
                </button>
            </div>

            <div class="filter-container" v-if="isFilterVisible">
                <div class="overlay-content">
                    <div class="filter-header">
                        <h2>{{this.translate.filter}}</h2>
                        <div class="close-filter-container">
                            <button @click="toggleFilterPanel" class="close-contact">
                                <span aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-close"></use>
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="filter-sections">
                        <div class="filter-section">
                            <div class="filter-title" @click="toggleDropdown(0)">
                                <span>{{this.translate.selectarea}}</span>
                                <span v-if="isOpen(0)" aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-up"></use>
                                    </svg>
                                </span>
                                <span v-else aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-down"></use>
                                    </svg>
                                </span>
                            </div>

                            <div v-if="activeFilter === 'plats'" class="filter-content">
                                <ul class="c-office-filter-mobile-dropdown">
                                    <div v-for="city in cities">
                                        <!-- {{ city.display}} -->
                                        <li class="c-office-filter__city">
                                            <label @click="addRegions(city)">
                                                <input type="checkbox" :value="city.value" v-model="selectedPlaces">
                                                {{ city.display }}
                                            </label>
                                        </li>
                                        <li class="c-office-filter__region" v-for="region in regions"
                                            v-if="region.group === city.display">
                                            <label>
                                                <input type="checkbox" :value="region.value" v-model="selectedPlaces">
                                                {{ region.display }}
                                            </label>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                            <div v-else></div>

                            <div class="filter-title" @click="toggleDropdown(1)">
                                <span>{{this.translate.selectpremise}}</span>
                                <span v-if="isOpen(1)" aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-up"></use>
                                    </svg>
                                </span>
                                <span v-else aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-down"></use>
                                    </svg>
                                </span>
                            </div>

                            <div v-if="activeFilter === 'lokal'" class="filter-content">
                                <ul class="c-office-filter-mobile-dropdown">
                                    <div v-for="premise in premiseType">
                                        <li class="c-office-filter__place">
                                            <label>
                                                <input type="checkbox" :value="premise.value"
                                                    v-model="selectedTypesOfBuildings">
                                                {{ premise.display }}
                                            </label>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                            <div v-else></div>

                            <div class="filter-title" @click="toggleDropdown(2)">
                                <span>{{this.translate.selectspace}}</span>
                                <span v-if="isOpen(2)" aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-up"></use>
                                    </svg>
                                </span>
                                <span v-else aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-chevron-down"></use>
                                    </svg>
                                </span>
                            </div>

                            <div v-if="activeFilter === 'yta'" class="filter-content">
                                <div class="c-office-filter__size-input-block">
                                    <div class="c-office-filter__size-input-heading">
                                       {{this.translate.selectdesiredspace}}
                                    </div>
                                    <div class="c-office-filter__size-input-wrapper">
                                        <div class="c-office-filter__size-input-container">
                                            <div class="c-office-filter__size-input-tag">Min</div>
                                            <input type="number" class="c-office-filter__size-input" placeholder="0"
                                                v-model="minSize">
                                            <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                        </div>
                                        <div aria-hidden="true"
                                            class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon">
                                            <svg>
                                                <use :xlink:href="`#icon-minus`"></use>
                                            </svg>
                                        </div>
                                        <div class="c-office-filter__size-input-container">
                                            <div class="c-office-filter__size-input-tag">Max</div>
                                            <input type="number" class="c-office-filter__size-input" placeholder="0"
                                                v-model="maxSize">
                                            <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else></div>
                        </div>
                    </div>

                    <div class="selected-tags">
                        <div v-for="(tag, index) in displayTags" :key="index" class="selected-tag">
                            <button @click="removeTag(tag.original)" class="close-tag">
                                <span aria-hidden="true" class="c-icon c-icon--xs">
                                    <svg>
                                        <use xlink:href="#icon-close"></use>
                                    </svg>
                                </span>
                            </button>
                            <span class="tag-container">
                                {{ tag.displayText }}
                            </span>
                        </div>
                        <div v-if="combinedTags.length > 4" class="show-all">
                            <a href="#" @click="resetFilter()">{{this.translate.showall}}</a>
                        </div>
                    </div>
                    <button class="result-button" @click="submitFilters">
                        {{this.translate.showresult}} ({{ objects.length }})
                    </button>
                </div>
            </div>
        </div>
        <div class="c-office-filter o-width-limiter--full" :class="{ 'c-office-filter__mobile': !isDesktop }"
            v-if="showFilters || isDesktop">
            <div class="c-office-filter__wrapper" :class="{ 'c-office-filter__wrapper-mobile': !isDesktop }">
                <div class="c-office-filter__content-wrapper">
                    <h3>{{this.translate.findpremise}}</h3>
                    <div class="c-office-filter__dropdown-wrapper">
                        <v-office-filter-dropdown @populate-filter="handleFilterData" tag="plats"
                            :button-text="placesButtonText" :select-area="this.translate.selectarea" :select="this.translate.select" :selecttag="this.translate.selectarealabel" :dropdown-open="this.activeFilter === 'plats'">
                            <ul class="c-office-filter-dropdown__list" v-if="this.activeFilter === 'plats'"
                                v-click-outside="handleClickOutside">

                                <div v-if="activeFilter === 'plats'" class="c-office-filter__city-wrapper"
                                    v-for="city in cities">
                                    <li class="c-office-filter__city">
                                        <label @click="addRegions(city)">
                                            <input type="checkbox" :value="city.value" v-model="selectedPlaces">
                                            {{ city.display }}
                                        </label>
                                    </li>
                                    <li class="c-office-filter__region" v-for="region in regions"
                                        v-if="region.group === city.display">
                                        <div>
                                            <label>
                                                <input type="checkbox" :value="region.value" v-model="selectedPlaces">
                                                {{ region.display }}
                                            </label>
                                        </div>
                                    </li>
                                </div>

                            </ul>
                        </v-office-filter-dropdown>
                        <v-office-filter-dropdown @populate-filter="handleFilterData" tag="lokal"
                            :button-text="typeOfBuildingButtonText" :select-area="this.translate.selectarea" :select="this.translate.select" :selecttag="this.translate.selectpremiselabel" :dropdown-open="this.activeFilter === 'lokal'">
                            <ul class="c-office-filter-dropdown__list" v-if="this.activeFilter === 'lokal'"
                                v-click-outside="handleClickOutside">
                                <div v-if="activeFilter === 'lokal'" class="c-office-filter__place-wrapper"
                                    v-for="premise in premiseType">
                                    <li class="c-office-filter__place">
                                        <label>
                                            <input type="checkbox" :value="premise.value"
                                                v-model="selectedTypesOfBuildings">
                                            {{ premise.display }}
                                        </label>
                                    </li>
                                </div>
                            </ul>
                        </v-office-filter-dropdown>
                        <v-office-filter-dropdown @populate-filter="handleFilterData" tag="yta"
                            :button-text="buildingSizeText" :select-area="this.translate.selectarea" :select="this.translate.select" :selecttag="this.translate.selectspacelabel" :dropdown-open="this.activeFilter === 'yta'">
                            <ul class="c-office-filter-dropdown__list" v-if="this.activeFilter === 'yta'"
                                v-click-outside="handleClickOutside">
                                <div v-if="activeFilter === 'yta'">
                                    <div class="c-office-filter__size-input-block">
                                        <div class="c-office-filter__size-input-heading">
                                            {{this.translate.showdesiredspace}}
                                        </div>
                                        <div class="c-office-filter__size-input-wrapper">
                                            <div class="c-office-filter__size-input-container">
                                                <div class="c-office-filter__size-input-tag">Min</div>
                                                <input type="number" class="c-office-filter__size-input" min="0"
                                                    placeholder="0" v-model="minSize">
                                                <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                            </div>
                                            <div aria-hidden="true"
                                                class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon">
                                                <svg>
                                                    <use :xlink:href="`#icon-minus`"></use>
                                                </svg>
                                            </div>
                                            <div class="c-office-filter__size-input-container">
                                                <div class="c-office-filter__size-input-tag">Max</div>
                                                <input type="number" class="c-office-filter__size-input" min="0"
                                                    placeholder="0" v-model="maxSize">
                                                <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ul>
                        </v-office-filter-dropdown>
                    </div>
                    <button class="clear-choises-button" @click="resetFilter">
                        {{this.translate.resetchoices}}
                    </button>
                </div>
                <div v-if="isDesktop" id="map" class="googlemapoffice">
                    <v-google-map v-if="isDesktop" :selectedPlaces="selectedPlaces" :selectedTypesOfBuildings="selectedTypesOfBuildings"
                        :minSize="minSize" :maxSize="maxSize" :objects="this.objects" :apiKey="this.apiKey" />
                </div>
            </div>
            <div class="c-office-filter__choices-container">
                <ul class="c-office-filter__list">
                    <div v-if="activeFilter === 'plats'" class="c-office-filter__city-wrapper" v-for="city in cities">
                        <!-- {{ city.display}} -->
                        <li class="c-office-filter__city">
                            <label @click="addRegionsMobile(city)">
                                <input type="checkbox" :value="city.value" v-model="selectedPlacesMobile">
                                {{ city.display }}
                            </label>
                        </li>
                        <li class="c-office-filter__region" v-for="region in regions"
                            v-if="region.group === city.display">
                            <label>
                                <input type="checkbox" :value="region.value" v-model="selectedPlacesMobile">
                                {{ region.display }}
                            </label>
                        </li>
                    </div>
                    <div v-if="activeFilter === 'lokal'" class="c-office-filter__place-wrapper"
                        v-for="premise in premiseType">
                        <li class="c-office-filter__place">
                            <label>
                                <input type="checkbox" :value="premise.value" v-model="selectedTypesOfBuildingsMobile">
                                {{ premise.display }}
                            </label>
                        </li>
                    </div>
                    <div v-if="activeFilter === 'yta'">
                        <div class="c-office-filter__size-input-block">
                            <div class="c-office-filter__size-input-heading">
                               {{this.translate.selectdesiredspace}}
                            </div>
                            <div class="c-office-filter__size-input-wrapper">
                                <div class="c-office-filter__size-input-container">
                                    <div class="c-office-filter__size-input-tag">Min</div>
                                    <input type="number" class="c-office-filter__size-input" placeholder="0"
                                        v-model="minSizeMobile">
                                    <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                </div>
                                <div aria-hidden="true" class="c-icon c-icon--xs c-office-filter-dropdown__toggle-icon">
                                    <svg>
                                        <use :xlink:href="`#icon-minus`"></use>
                                    </svg>
                                </div>
                                <div class="c-office-filter__size-input-container">
                                    <div class="c-office-filter__size-input-tag">Max</div>
                                    <input type="number" class="c-office-filter__size-input" placeholder="0"
                                        v-model="maxSizeMobile">
                                    <span class="c-office-filter__size-input-m2-tag">m<sup>2</sup></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ul>
            </div>
            <div class="c-office-filter__button-container">
                <button class="c-office-filter__button-cancel" @click="showFilters = !showFilters">{{this.translate.cancel}}</button>
                <button class="c-office-filter__button-save" @click="applyFiltersMobile">Applicera</button>
            </div>
        </div>
    </div>
</template>

<script>
import VOfficeFilterDropdown from './dropdown/VOfficeFilterDropdown.vue'
import VOfficeFilterDropdownMobile from './dropdown/VOfficeFilterDropdownMobile.vue'
import vClickOutside from "v-click-outside";
import VGoogleMap from './VGoogleMap.vue';

export default {
    name: 'VFilter',
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        VOfficeFilterDropdown,
        VOfficeFilterDropdownMobile,
        VGoogleMap
    },

    props: {
        objects: {
            type: Array,
        },
        multiSelectFilters: {
            type: Array,
            default: () => []
        },
        objectsFetched: {
            type: Boolean,
            default: false
        },
        apiKey: {
			type: String,
			required: true
		},
        translationString: {
            type: Object
        }
    },

    data() {
        return {
            cities: [],
            regions: [],
            premiseType: [],
            showSortingOptions: false,
            sortOptions: [
                {
                    display: 'Adress: A - Ö',
                    value: 1
                },
                {
                    display: 'Adress: Ö - A',
                    value: 2
                },
                {
                    display: 'Senaste objekt',
                    value: 3
                },
                {
                    display: 'Yta: minst',
                    value: 4,
                },
                {
                    display: 'Yta: störst',
                    value: 5
                }
            ],
            activeSorting: {},
            activeFilter: '',
            selectedPlaces: [],
            selectedTypesOfBuildings: [],
            minSize: '',
            maxSize: '',
            selectedPlacesMobile: [],
            selectedTypesOfBuildingsMobile: [],
            minSizeMobile: '',
            maxSizeMobile: '',
            hits: [],
            showFilters: false,
            isDesktop: false,
            isFilterVisible: false,
            translate: {},
            filters: [
                {
                    name: 'Område',
                    type: 'plats',
                    options: ['Utförande 1', 'Utförande 2', 'Utförande 3'],
                    selectedOptions: [],
                },
                {
                    name: 'Lokal',
                    type: 'lokal',
                    options: ['Lokal 1', 'Lokal 2', 'Lokal 3'],
                    selectedOptions: [],
                },
                {
                    name: 'Yta',
                    type: 'yta',
                    options: ['Yta 1', 'Yta 2', 'Yta 3'],
                    selectedOptions: [],
                },
            ],
            activeDropdown: null,
        }
    },
    methods: {
        toggleFilterPanel() {
            this.isFilterVisible = !this.isFilterVisible;
            this.showMobileFilters;
            this.applyFiltersMobile;
        },
        toggleDropdown(index) {
            const filterNames = ['plats', 'lokal', 'yta'];
            const selectedFilter = filterNames[index];

            this.activeFilter = this.activeFilter === selectedFilter ? '' : selectedFilter;
            this.activeDropdown = this.activeDropdown === index ? null : index;
        },
        isOpen(index) {
            return this.activeDropdown === index;
        },
        removeTag(tag) {
            if (this.selectedPlaces.includes(tag)) {
                this.selectedPlaces = this.selectedPlaces.filter(t => t !== tag);
            }
            if (this.selectedTypesOfBuildings.includes(tag)) {
                this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(t => t !== tag);
            }
        },
        capitalizeFirstLetter(tag) {
            return tag
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
        },
        submitFilters() {
            this.isFilterVisible = false;
        },
        handleFilterData(data) {
            let filter

            data.forEach(element => {
                filter = element.tag
            })
            if (window.screen.width >= 768 && this.activeFilter === filter) {
                this.activeFilter = ''
            } else if (window.screen.width >= 768 && this.activeFilter !== '') {
                this.activeFilter = filter
            } else if (window.screen.width >= 768 && this.activeFilter === '') {
                this.activeFilter = filter
            } else if (window.screen.width < 768) {
                this.activeFilter = filter
            }
        },
        selectSortingOption(option) {
            this.activeSorting = option
            this.showSortingOptions = false
        },
        addRegions(city) {
            this.regions.forEach(region => {
                if ((region.group === city.value) && (!this.selectedPlaces.includes(region.value)) && (!this.selectedPlaces.includes(city.value))) {
                    this.selectedPlaces.push(region.value)
                }
                else if (this.selectedPlaces.includes(city.value)) {
                    this.selectedPlaces.forEach((selected, index) => {
                        const [place, regionCity] = selected.split('-');
                        const cityToLower = city.value.toLowerCase();
                        if (selected === region.value && regionCity === cityToLower) {
                            this.selectedPlaces.splice(index, 1);
                        }
                    });
                }
            })
        },
        addRegionsMobile(city) {
            this.regions.forEach(region => {
                if ((region.group === city.value) && (!this.selectedPlacesMobile.includes(region.value)) && (!this.selectedPlacesMobile.includes(city.value))) {
                    this.selectedPlacesMobile.push(region.value)
                } else if (this.selectedPlacesMobile.includes(city.value)) {
                    this.selectedPlacesMobile.forEach((selected, index) => {
                        if (selected === region.value) {
                            this.selectedPlacesMobile.splice(index, 1);
                        }
                    });
                }
            })
        },
        resetFilter() {
            this.activeSorting = this.sortOptions[2]
            this.selectedPlaces = []
            this.selectedPlacesMobile = []
            this.selectedTypesOfBuildings = []
            this.selectedTypesOfBuildingsMobile = []
            this.minSize = ''
            this.minSizeMobile = ''
            this.maxSize = ''
            this.maxSizeMobile = ''
            this.activeFilter = ''
            this.showFilters = false
        },
        setMultiSelectFilter(filter) {
            this.$emit('setMultiSelectFilter', filter);
        },
        setSelectedPlacesLength(length) {
            this.$emit('setSelectedPlacesLength', length)
        },
        setSelectedTypesOfBuildingsLength(length) {
            this.$emit('setSelectedTypesOfBuildingsLength', length)
        },
        setMinSize(size) {
            this.$emit('setMinSize', size)
        },
        setMaxSize(size) {
            this.$emit('setMaxSize', size)
        },
        setSortingOption(option) {
            this.$emit('setSortingOption', option)
        },
        checkScreenSize() {
            this.isDesktop = window.innerWidth >= 768;
        },
        showMobileFilters() {
            this.activeFilter = 'plats'
            this.showFilters = true
        },
        applyFiltersMobile() {
            this.selectedPlaces = this.selectedPlacesMobile
            this.selectedTypesOfBuildings = this.selectedTypesOfBuildingsMobile
            this.minSize = this.minSizeMobile
            this.maxSize = this.maxSizeMobile
            this.showFilters = false
        },
        handleClickOutside() {
            if (this.activeFilter === 'plats' && this.isDesktop) {
                this.activeFilter = ''
            } else if (this.activeFilter === 'lokal' && this.isDesktop) {
                this.activeFilter = ''
            } else if (this.activeFilter === 'yta' && this.isDesktop) {
                this.activeFilter = ''
            }

            if (this.showSortingOptions && this.isDesktop) {
                this.showSortingOptions = false
            }

        },
        setQueryParams() {
            let selectedOptions = [];
            let url = window.location.toString();
            let cleanUrl = url.split('?')[0];

            this.selectedPlaces.filter(place => {
                selectedOptions.push(place);
            });

            this.selectedTypesOfBuildings.filter(premise => {
                selectedOptions.push(premise);
            });

            if (this.minSize !== '' || this.maxSize !== '') {
                selectedOptions.push('area:' + this.minSize, this.maxSize);
            }

            let newUrl = this.replaceUrlParam(cleanUrl, selectedOptions.join('%2C'));
            newUrl = new URL(newUrl);
            window.history.replaceState({}, '', newUrl.search);

        },
        replaceUrlParam(url, value) {
            if (value.length === 0) {
                value = '';
            }
            let pattern = new RegExp('\\b(' + '=).*?(&|#|$)');
            if (url.search(pattern) >= 0) {
                return url.replace(pattern, '$1' + value + '$2');
            }
            url = url.replace(/[?#]$/, '');
            return url + (url.indexOf('?') > 0 ? '&' : '?') + '=' + value;
        },
        getQueryParamsFromURL() {
            let regex = new RegExp('[\\?&]' + '=([^&#]*)');
            let results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        },
        setFilterFromParams(values) {
            values.forEach((value) => {
                this.multiSelectFilters[0].items.forEach(item => {
                    if (item.value === value) {
                        this.selectedPlaces.push(value)
                        this.selectedPlacesMobile.push(value)
                    }
                })
                this.multiSelectFilters[1].items.forEach(item => {
                    if (item.value === value) {
                        this.selectedTypesOfBuildings.push(value)
                        this.selectedTypesOfBuildingsMobile.push(value)
                    }
                })
                if (value.includes("area:")) {
                    let areaValues = value.split(":")[1].split(",");
                    let minSize = areaValues[0].trim();
                    this.minSize = minSize
                    this.minSizeMobile = minSize
                    this.maxSize = values[values.length - 1]
                    this.maxSizeMobile = values[values.length - 1]
                }
            });
        },
        handleRemovePlace(value) {
            this.selectedPlaces = this.selectedPlaces.filter(place => place !== value);
            this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(place => place !== value);
            this.updateSelectedPlaces();
            this.updateSelectedTypesOfBuildings();
        },
        updateSelectedPlaces() {
            this.regions.forEach(region => {
                if (!this.selectedPlaces.includes(region.value) && this.selectedPlaces.includes(region.group)) {
                    this.selectedPlaces = this.selectedPlaces.filter(place => place !== region.group);
                }
            });
            this.setSelectedPlacesLength(this.selectedPlaces.length);
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces));
            this.setQueryParams();
        },
        updateSelectedTypesOfBuildings() {
            this.setSelectedTypesOfBuildingsLength(this.selectedTypesOfBuildings.length)
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces))
            this.setQueryParams();
        },
        removeTag(tagToRemove) {
            this.selectedPlaces = this.selectedPlaces.filter(tag => tag !== tagToRemove);
            this.selectedTypesOfBuildings = this.selectedTypesOfBuildings.filter(tag => tag !== tagToRemove);
        }
    },
    computed: {
        displayTags() {
            const tags = this.combinedTags.map((tag) => {
                const [firstPart] = tag.split("-");
                return {
                    original: tag,
                    displayText: firstPart.charAt(0).toUpperCase() + firstPart.slice(1)
                };
            });

            return tags.slice(0, 4);
        },
        combinedTags() {
            return [...this.selectedPlaces, ...this.selectedTypesOfBuildings];
        },
        selectedFilters() {
            return this.filters.flatMap(filter => filter.selectedOptions);
        },
        filteredResults() {
            return Array(this.selectedFilters.length || 87).fill('Result');
        },
        hasSelectedFilters() {
            return this.selectedFilters.length > 0;
        },
        placesButtonText() {
            if (this.selectedPlaces.length === 0) {
                return this.translate.selectarea
            } else {
                return this.selectedPlaces.length + ' valda'
            }
        },
        typeOfBuildingButtonText() {
            if (this.selectedTypesOfBuildings.length === 0) {
                return this.translate.selectpremise
            } else {
                return this.selectedTypesOfBuildings.length + ' valda'
            }
        },
        buildingSizeText() {
            if (this.minSize === '' && (this.maxSize === '' || this.maxSize === '0')) {
                return this.translate.selectspace
            }
            else {
                return this.minSize + ' - ' + this.maxSize + ' m2'
            }
        }
    },
    watch: {
        selectedPlaces() {
            this.regions.forEach(region => {
                if (!this.selectedPlaces.includes(region.value) && this.selectedPlaces.includes(region.group)) {
                    this.selectedPlaces = this.selectedPlaces.filter(place => place !== region.group)
                }
            })
            this.setSelectedPlacesLength(this.selectedPlaces.length)
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces))
            this.setQueryParams();
            
        },
        selectedTypesOfBuildings() {
            this.setSelectedTypesOfBuildingsLength(this.selectedTypesOfBuildings.length)
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces))
            this.setQueryParams();
        },
        minSize() {
            this.setMinSize(this.minSize)
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces))
            this.setQueryParams();
        },
        maxSize() {
            this.setMaxSize(this.maxSize)
            this.setMultiSelectFilter(this.selectedTypesOfBuildings.concat(this.selectedPlaces))
            this.setQueryParams();
        },
        activeSorting() {
            this.setSortingOption(this.activeSorting)
        },
        activeFilter() {
            this.multiSelectFilters.forEach(filter => {
                if (filter.name === "location") {
                    filter.items.forEach(item => {
                        if (item.groupLabel && !this.cities.includes(item)) {
                            this.cities.push(item)
                        } else if (!this.regions.includes(item)) {
                            this.regions.push(item)
                        }

                    })
                } else if (filter.name === "premisetype") {
                    filter.items.forEach(item => {
                        if (!this.premiseType.includes(item)) {
                            this.premiseType.push(item)
                        }
                    })
                }
            })
        },
        showFilters() {
            document.querySelector('body').style.overflow = this.showFilters ? 'hidden' : 'auto';
        },
        objectsFetched() {
            let queryParams = this.getQueryParamsFromURL();
            queryParams = decodeURI(queryParams);

            if (queryParams) {
                let values = queryParams.split(",");
                this.setFilterFromParams(values);
            }
            this.setQueryParams()
        }
    },
    created() {
        this.translate = JSON.parse(this.translationString);
        this.activeSorting = this.sortOptions[2];
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    destroyed() {
        window.removeEventListener('resize', this.checkScreenSize)
    },
}
</script>